<template>
	<div class="p-mb-6">
		<div>
			<p>
				<!--<b>{{ question }}</b>-->
				<b v-if="questionMark">
					<QuestionComments :questionMark="questionMark" :question="question" />
				</b>
				<b v-else> {{ question }} </b>
			</p>
			<HelpTooltip v-if="bookmark != undefined" :helpbookmark="bookmark" />
		</div>
		<!-- Listen to on change event instead of v-on:input to achieve same result as v-model.lazy -->
		<el-date-picker
			v-model="date"
			type="date"
			format="dd/MM/yyyy"
			value-format="MM/dd/yyyy"
			:placeholder="placeholder"
		/>
	</div>
</template>

<script>
import HelpTooltip from "../components/HelpTooltip";
import QuestionComments from "./QuestionComments.vue";
export default {
	name: "InputElDate",
	props: {
		question: String,
		placeholder: String,
		value: [Object, String], //String Or Object
		bookmark: String,

		questionMark: String
	},
	computed: {
		date: {
			get() {
				if (!this.value || this.value.nullValue) {
					return "";
				}
				return this.value;
			},
			set(newValue) {
				//console.log("newDate:", newValue);
				this.$emit("update:value", newValue);
			}
		}
	},
	components: {
		HelpTooltip,
		QuestionComments
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
